import React from 'react';
import './App.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import { renderRoutes } from 'react-router-config';


function App(props) {
  return (          
    <CssBaseline>      
      { renderRoutes(props.route.routes, { adsCount: "137.843" }) }      
    </CssBaseline>          
  );
}

export default App;
